module.exports = __webpack_public_path__ + "img/ico_update.93650bc2.svg";